import { useState, useCallback } from 'react';

interface UseAddCenterDialogResult {
    dialogOpen: boolean;
    selectedCodes: string[];
    openDialog: () => void;
    closeDialog: () => void;
    toggleCenter: (centerCode: string) => void;
    toggleAll: (allCodes: string[]) => void;
    resetSelection: () => void;
}

export const useAddCenterDialog = (): UseAddCenterDialogResult => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedCodes, setSelectedCodes] = useState<string[]>([]);

    const openDialog = useCallback(() => {
        setDialogOpen(true);
    }, []);

    const closeDialog = useCallback(() => {
        setSelectedCodes([]);
        setDialogOpen(false);
    }, []);

    const toggleCenter = useCallback((centerCode: string) => {
        setSelectedCodes(prev =>
            prev.includes(centerCode)
                ? prev.filter(code => code !== centerCode)
                : [...prev, centerCode]
        );
    }, []);

    const toggleAll = useCallback((allCodes: string[]) => {
        setSelectedCodes(prev =>
            prev.length === allCodes.length ? [] : allCodes
        );
    }, []);

    const resetSelection = useCallback(() => {
        setSelectedCodes([]);
    }, []);

    return {
        dialogOpen,
        selectedCodes,
        openDialog,
        closeDialog,
        toggleCenter,
        toggleAll,
        resetSelection
    };
};
